module.exports = __webpack_public_path__ + "media/images/client-logos/client-logo_vodafone-03b4c364767cfb30519b4a9a33cb6116.png";